<template>
   <div>
     <div class="columns is-multiline">
             <b-loading  :active.sync="isFullScreenSearching" ></b-loading>               
                           
                     
                           
                            <div class="column is-one-quarter-desktop is-half-tablet"   v-for="img in CBCImages" :key="img.id" >
                          
                              <div class="card"  style="border: 0.5px solid #ff0000;">
                                <div class="card-image" >
                                        <figure class="image is-4by3"  >
                                                <img :src="getURLImgWithUUID( img.path )"  >
                                        </figure>
                                    </div>
                                    <footer class="card-footer">
                                          
                                       
                                           <a class="card-footer-item" @click="imageModal(getURLImgWithUUID( img.path ))">
                                              <b-tooltip label="View">
                                                <b-icon
                                                        icon="magnify"
                                                        size="is-medium">
                                                </b-icon>
                                              </b-tooltip>
                                            </a>
                                       
                                        
                                        <a class="card-footer-item" @click="disableImage(img.id)"    >
                                            <b-tooltip label="Delete" type="is-danger">
                                                <b-icon
                                                        icon="delete"
                                                        size="is-medium"
                                                        type="is-danger"
                                                        >
                                                </b-icon>
                                            </b-tooltip>
                                        </a>
                                    </footer>
                              </div>
                                    
                                

                                 


                            </div>

                             <b-button 
                                type="is-primary is-light"
                                class="mt-5"
                                icon-left="plus"
                                @click="addImages"
                                >
                                Add New Image
                             </b-button>
    </div> 

   

    <b-modal :active.sync="isImageModalActive">
        <p class="image ">
            <img :src=dataUrl>
        </p>
    </b-modal>   





    <b-modal
            v-if="isDlgImagesUploadBufferShowing"
            v-model="isDlgImagesUploadBufferShowing"
            has-modal-card
            full-screen
            :can-cancel="true">
        <DlgImagesUploadBuffer 
            :isComponentModalActive="isDlgImagesUploadBufferShowing"  
            :forJob="1"
            :forIDLAB="dataToEdit_ManuallyLabAutomate.info.idlab"
            @close="closeDlgImagesUploadBuffer"
            @closeWithUpdate = "closeDlgImagesUploadBuffer_WithUpdate"/>
    </b-modal>






   </div>
    
    
</template>


<script>

import { mapActions , mapState  } from "vuex";
import {  getBaseURLLabCBCImages , genUUID}  from '@/utils.js' 


import axios from "axios";
import {getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'


import DlgImagesUploadBuffer from '../../UtilsComponents/DlgImagesUploadBuffer/DlgImagesUploadBuffer.vue'


export default {
    name : "CBC_Images",
    computed:{
            ...mapState({
                access_token : state => state.master_data.access_token,
                CBCImages: state => state.manually_create_lab_automate.CBCImages ,
                dataToEdit_ManuallyLabAutomate: state => state.manually_create_lab_automate.dataToEdit_ManuallyLabAutomate ,
            }),
    },
    components:{
        DlgImagesUploadBuffer,
    },
    methods:{
        ...mapActions({
            fetchOnlyCBCImages : 'manually_create_lab_automate/fetchOnlyCBCImages'
        }),
       





        closeDlgImagesUploadBuffer_WithUpdate(){
            // this.setHasEditImagesHappenWhenEdit(true)
            this.isDlgImagesUploadBufferShowing = false
            // this.isFullScreenSearching = true
            this.fetchOnlyCBCImages(this.dataToEdit_ManuallyLabAutomate['info'].idlab)
                
        },
        closeDlgImagesUploadBuffer(){
            this.isDlgImagesUploadBufferShowing = false
        },
        addImages(){
            this.isDlgImagesUploadBufferShowing = true
        },






        getURLImgWithUUID(path){
              return `${getBaseURLLabCBCImages()}${this.dataToEdit_ManuallyLabAutomate['info'].idlab}/${path}?${genUUID(12)}`
        },
        loadCBCImage(){
            this.isFullScreenSearching = true
            this.fetchOnlyCBCImages(this.dataToEdit_ManuallyLabAutomate['info'].idlab)
                 .then(()=>{
                    this.isFullScreenSearching = false
                 })
        },
        disableImage(_id){
            this.isFullScreenSearching = true
            const datTo = {
                    "id_img" : _id
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token})}`
            axios.post(`${getBaseURLforBackEnd()}/api/disableimagecbc`, datTo , getConfigAxios())
                .then((res)=>{
                            this.$buefy.toast.open({
                                duration: 500,
                                message: `${res.data.msg}`,
                                position: 'is-bottom',
                                type: 'is-success'
                            })
                            this.isFullScreenSearching = false
                            // load image again
                            this.loadCBCImage() 
                })
                .catch((err)=>{
                            this.isFullScreenLoading = false
                            this.$buefy.toast.open({
                                    duration: 1000,
                                    message: `${err.data}`,
                                    position: 'is-bottom',
                                    type: 'is-success'
                             })
                 
                })
          
        },
        imageModal(dataUrl){
            if(dataUrl !== "") {
                    this.dataUrl = dataUrl 
                }else{
                    this.dataUrl = 'imgnotaval.jpg'
                }
                this.isImageModalActive = true
        },
    },
    data(){
        return {
            isImageModalActive : false, 
            dataUrl : "",
            isFullScreenSearching : false,   


            isDlgImagesUploadBufferShowing : false,
        }
    }        
}
</script>



<style scoped>


   img{
        cursor: pointer;
        width:100%;
        height:100%;
        object-fit: contain;

    }

 

</style>    